<template>
    <div>
        <div class="container" style="min-width: 900px">
            <el-form :inline="true" ref="userForm" :model="user" :rules="rules" class="demo-form-inline">
                <el-form-item label="玩家ID" prop="userId">
                    <el-input v-model="user.userId" placeholder="ID" style="width: 260px;" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="offline('userForm')">封 禁</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { bannedUserTOGM } from '../../../api/gameconsole-mars.js'
export default {
    name: 'MarsManager',
    data: function(){
        return {
            user: {
                userId: '',
            },
            rules: {
                userId: [
                    { required: true, message: '玩家ID不能为空', trigger: 'blur'},
                    { min: 32, max: 32, message: 'ID长度在32位', trigger: 'blur' }
                ]
            },
        }
    },
    created() {

    },
    methods: {
        /**
         * 封禁玩家
         */
        offline(userForm) {
            this.$refs[userForm].validate((valid) => {
                if (valid) {
                    let params = {'userId': this.user.userId }
                    bannedUserTOGM(params).then(res => {
                        if(res.data.code == 200) {
                            this.$message.success(res.data.message)
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }
            })
        }
    }
}

</script>